var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "language-proficiency" },
    [
      _c(
        "form",
        {
          ref: "languageProficiencyForm",
          attrs: { method: "post" },
          on: { submit: _vm.disablePassBtn }
        },
        [
          _c("input", {
            attrs: { type: "hidden", name: "_csrfToken" },
            domProps: { value: _vm.csrfToken }
          }),
          _vm._v(" "),
          _c("input", {
            attrs: { type: "hidden", name: "fail_reason" },
            domProps: { value: _vm.fail_reason }
          }),
          _vm._v(" "),
          _c("input", {
            attrs: { type: "hidden", name: "language_proficiency_status" },
            domProps: { value: _vm.language_proficiency_status }
          }),
          _vm._v(" "),
          _vm._l(_vm.jobApplication.language_proficiency_scores, function(
            langProf,
            i
          ) {
            return _c(
              "div",
              {
                key: langProf.id,
                staticClass: "bg-white rounded p-3 pt-2",
                class: {
                  "pb-0":
                    i <
                    _vm.jobApplication.language_proficiency_scores.length - 1
                }
              },
              [
                _c("div", { staticClass: "grid-x grid-padding-x mb-3" }, [
                  _c("div", { staticClass: "cell small-6" }, [
                    _c("input", {
                      attrs: {
                        type: "hidden",
                        name: "language_proficiency_scores[" + i + "][id]"
                      },
                      domProps: { value: langProf.id }
                    }),
                    _vm._v(" "),
                    _c("label", [_vm._v("Recording " + _vm._s(i + 1) + ":")]),
                    _vm._v(" "),
                    _c("div", { staticClass: "mb-2 mt-2" }, [
                      langProf.file_path !== null
                        ? _c("audio", { attrs: { controls: "" } }, [
                            _c("source", {
                              attrs: {
                                src: "" + langProf.file_path_cdn,
                                type: "audio/mpeg"
                              }
                            }),
                            _vm._v(
                              "\n                            Your browser does not support the audio element.\n                        "
                            )
                          ])
                        : _c("div", [_vm._v("Voice note record unavailable")])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-control px-0 mb-2" }, [
                      _c("p", [
                        _c(
                          "a",
                          {
                            staticClass: "text-danger",
                            on: {
                              click: function($event) {
                                return _vm.confirmDeleteVoice(langProf.id)
                              }
                            }
                          },
                          [_vm._v("Delete")]
                        )
                      ]),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v("Algorithm Score: "),
                        _c("strong", [
                          _c("i", [_vm._v(_vm._s(langProf.confidence) + "%")])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("p", [_vm._v("Recruiter score:")]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "d-flex align-items-center gap-2" },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: langProf.score,
                                expression: "langProf.score"
                              }
                            ],
                            staticClass: "mt-2",
                            staticStyle: { width: "unset" },
                            attrs: {
                              type: "number",
                              step: "1",
                              min: "0",
                              max: "100",
                              required: "",
                              name:
                                "language_proficiency_scores[" + i + "][score]"
                            },
                            domProps: { value: langProf.score },
                            on: {
                              change: _vm.setAverageScore,
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(langProf, "score", $event.target.value)
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("span", [_vm._v("%")])
                        ]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "cell small-4 lang-prof-desc" }, [
                    _c("p", { staticClass: "mt-4" }, [
                      _vm._v(_vm._s(langProf.text))
                    ])
                  ])
                ]),
                _vm._v(" "),
                i < _vm.jobApplication.language_proficiency_scores.length - 1
                  ? _c("hr")
                  : _vm._e()
              ]
            )
          }),
          _vm._v(" "),
          _vm.jobApplication.language_proficiency_scores.length === 0
            ? _c("p", [_vm._v("Candidate has not uploaded any audio clips")])
            : _vm._e(),
          _vm._v(" "),
          _vm.jobApplication.language_proficiency_scores.length > 0
            ? [
                _c(
                  "div",
                  { staticClass: "px-3" },
                  [
                    _c("hr", { staticStyle: { "max-width": "unset" } }),
                    _vm._v(" "),
                    _c("span", [_vm._v("Average Algorithm Score: ")]),
                    _vm._v(" "),
                    _c("span", {}, [
                      _c("strong", [
                        _c("i", [_vm._v(_vm._s(_vm.average) + "%")])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" "),
                    _vm.jobApplication.language_proficiency_status != null
                      ? [
                          _c("span", [_vm._v("Final Status: ")]),
                          _vm._v(" "),
                          _c("strong", [
                            _vm._v(
                              _vm._s(
                                _vm.jobApplication.language_proficiency_status
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _vm.logs !== null && _vm.logs !== ""
                            ? _c("small", [
                                _vm._v(
                                  "\n                         (Updated By " +
                                    _vm._s(_vm.logs.user.first_name) +
                                    " " +
                                    _vm._s(_vm.logs.user.last_name) +
                                    " - " +
                                    _vm._s(_vm.convertDate(_vm.logs.created)) +
                                    ")\n                    "
                                )
                              ])
                            : _vm._e()
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _c("hr", { staticStyle: { "max-width": "unset" } })
                  ],
                  2
                )
              ]
            : [
                _c("hr", { staticStyle: { "max-width": "unset" } }),
                _vm._v(" "),
                _c("span", [_vm._v("Final Status: ")]),
                _vm._v(" "),
                _c("strong", [
                  _vm._v(_vm._s(_vm.jobApplication.language_proficiency_status))
                ]),
                _vm._v(" "),
                _vm.logs !== null && _vm.logs !== ""
                  ? _c("small", [
                      _vm._v(
                        "\n                 (Updated By " +
                          _vm._s(_vm.logs.user.first_name) +
                          " " +
                          _vm._s(_vm.logs.user.last_name) +
                          " - " +
                          _vm._s(_vm.convertDate(_vm.logs.created)) +
                          ")\n            "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("hr", { staticStyle: { "max-width": "unset" } })
              ],
          _vm._v(" "),
          _c("div", { staticClass: "grid-x grid-padding-x mt-4" }, [
            _c("div", { staticClass: "cell shrink" }, [
              _c("input", {
                attrs: {
                  type: "hidden",
                  name: "language_proficiency_progress"
                },
                domProps: { value: _vm.progress_submission_status }
              }),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "button success px-5",
                  attrs: {
                    type: "submit",
                    value: "progress_submission",
                    disabled: _vm.passBtnDisabled
                  }
                },
                [_vm._v("Save Progress")]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "cell shrink" }, [
              _c(
                "button",
                {
                  staticClass: "button px-5",
                  attrs: { type: "submit", disabled: _vm.passBtnDisabled }
                },
                [_vm._v("Pass")]
              )
            ]),
            _vm._v(" "),
            _c("div", [
              _c("button", {
                ref: "failedButton",
                staticClass: "d-none",
                attrs: { value: "failed", name: "language_proficiency_status" }
              }),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "button alert px-5",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      return _vm.toggleModal("failModal")
                    }
                  }
                },
                [_vm._v("Fail")]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "cell shrink" }, [
              _c(
                "button",
                {
                  staticClass: "button recycle px-5",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      return _vm.toggleModal("recycleModal")
                    }
                  }
                },
                [_vm._v("Recycle")]
              )
            ]),
            _vm._v(" "),
            _vm._m(0)
          ])
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "form",
        {
          ref: "form",
          attrs: {
            method: "post",
            action:
              "/recruiter/active-requisitions/delete-voice-note?jobApplication=" +
              _vm.jobApplication.id
          }
        },
        [
          _c("input", {
            attrs: { type: "hidden", name: "voice_note_id" },
            domProps: { value: _vm.voiceWillBeDeleted }
          }),
          _vm._v(" "),
          _c("input", {
            attrs: { type: "hidden", name: "_csrfToken" },
            domProps: { value: _vm.csrfToken }
          }),
          _vm._v(" "),
          _c(
            "button",
            {
              ref: "btnDeleteVoiceNote",
              staticClass: "hide",
              attrs: { type: "submit" }
            },
            [_vm._v("Submit")]
          )
        ]
      ),
      _vm._v(" "),
      _c("recycle-modal", {
        ref: "recycleModal",
        attrs: {
          "job-application": _vm.jobApplication,
          "csrf-token": _vm.csrfToken
        }
      }),
      _vm._v(" "),
      _c("fail-modal", {
        ref: "failModal",
        attrs: { "job-application": _vm.jobApplication },
        on: { submit: _vm.fail }
      }),
      _vm._v(" "),
      _c("modal-confirm", {
        ref: "confirmModal",
        attrs: {
          message: "Are you sure you want to delete this voice recording?"
        },
        on: { confirmed: _vm.submitDeleteVoice }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c(
        "button",
        {
          staticClass: "button warning text-white",
          attrs: { type: "submit", value: "request_resubmission" }
        },
        [_vm._v("Request Resubmission")]
      )
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-62db2410", { render: render, staticRenderFns: staticRenderFns })
  }
}